<template>

    <div>
        ERROR
    </div>

</template>

<script>

import { Vue, Options } from 'vue-class-component'

export default Options({
    name: 'Error'
})(
    class Error extends Vue
    {

    }
)

</script>